import { AuditColumnModel } from "src/app/model"

export interface UserRoleModel extends Pick<AuditColumnModel, "_id"> {
  roleName: string;
  roletypes: {
    roletype: string;
    color: string;
  }
}

export interface UserTradeModel extends Pick<AuditColumnModel, "_id"> {
  tradeName: string;
}

export interface UserModel extends Pick<AuditColumnModel, "_id"> {
  name: {
    first: string;
    middle: string;
    last: string;
  },
  phone: {
    country: string;
    countryCode: number;
    number: number;
  },
  email: string;
  image: string;
  thumbnail: string;
  empId: string;
  personal: {
    dob: string;
    gender: string;
    nationality: string;
    bloodGroup: string;
  },
  status: boolean;
  registrationStatus: string;
  approverComments: string;
  userComments: string;
  mobileToken: string;
  mobileAppId: string;
  entityIds: string[],
  sites: string[],
  roles: UserRoleModel[],
  trades: UserTradeModel[];
  entitysupervisor: string[];
  credentials: {
    userId: string;
    userGroup: string;
    userName: string;
  }[];
}